import { combineReducers } from 'redux';
import contentLabelReducer from './content_lable.reducer';

const contentLabelAppReducer = combineReducers({
    contentLabelReducer,
});

export default contentLabelAppReducer;


// WEBPACK FOOTER //
// src/main/content/content_label/store/reducers/index.js